/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Text } from '@mantine/core';
import classes from './TableAdditionalityProjects.module.css';
import clsx from 'clsx';
import { truncateString, uuid } from '@utils/functions';
import { Tooltip } from '@components/atoms/Tooltip';
import { useTranslation } from 'react-i18next';

export const TableAdditionalityProjects = (props: {
	rows: any;
}) => {
	const { t } = useTranslation();

	return (
		<Box className={classes.table}>
			<Box className={classes.header}>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.project')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text className={classes.title}>
						{t('global.total')}
					</Text>
				</Box>
			</Box>
			{props.rows &&
				props.rows.map((item: any) => (
					<Box key={uuid()} className={classes.row}>
						<Tooltip
							isActive={
								item.name && item.name.length > 27
							}
							label={item && item.name ? item.name : ''}
						>
							<Box className={classes.cell}>
								<Text className={classes.value}>
									{truncateString(item.name, 27)}
								</Text>
							</Box>
						</Tooltip>

						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Text className={classes.value}>
								{item.total}
							</Text>
						</Box>
					</Box>
				))}
		</Box>
	);
};
